import isNil from 'lodash/isNil'
import { useMemo } from 'react'

import {
  useFetchBankTransactions,
  UseFetchBankTransactionsProps,
  UseFetchBankTransactionsResponse,
} from '@features/bankTransactions/hooks/useFetchBankTransactions'
import { BankLinesQueryParams } from '@features/bankTransactions/query-api'

import { useSandboxModeContext } from '../contexts/sandboxModeContext'
import { selectSandboxBankLines } from '../utils/selectSandboxBankLines'

const fetchNextSandboxPage = () => undefined

export const useSandboxBankTransactions = (props: UseFetchBankTransactionsProps): UseFetchBankTransactionsResponse => {
  const sandbox = useSandboxModeContext()
  const result = useFetchBankTransactions({ ...props, enabled: !sandbox && props.enabled })

  const queryParams = useMemo<BankLinesQueryParams>(
    () => ({
      accountId: props.accountId,
      ...(!isNil(props.isReconciled) ? { isReconciled: props.isReconciled } : {}),
      ...(!isNil(props.maxAmount) ? { maxAmount: props.maxAmount } : {}),
      ...(!isNil(props.minAmount) ? { minAmount: props.minAmount } : {}),
      ...(props.period ? { entryDatePeriod: props.period } : {}),
      ...(props.searchQuery ? { q: props.searchQuery } : {}),
      ...(props.transactionTypeFilter ? { side: props.transactionTypeFilter } : {}),
      ...(props.sortDirection ? { sortDirection: props.sortDirection } : {}),
      ...(props.sortProperty ? { sortProperty: props.sortProperty } : {}),
      ...(props.status ? { status: props.status } : {}),
    }),
    [props],
  )

  if (!sandbox) {
    return result
  }

  return {
    bankTransactions: selectSandboxBankLines(sandbox.sandboxState.bankLines, queryParams),
    fetchNextPage: fetchNextSandboxPage,
    hasNextPage: false,
    isFetchingNextPage: false,
    isLoading: false,
  }
}
